var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _RecipientContextImpl_mutex;
import { EMPTY, OpenError, toArrayBuffer } from "@hpke/common";
import { EncryptionContextImpl } from "./encryptionContext.js";
import { Mutex } from "./mutex.js";
export class RecipientContextImpl extends EncryptionContextImpl {
    constructor() {
        super(...arguments);
        _RecipientContextImpl_mutex.set(this, void 0);
    }
    async open(data, aad = EMPTY.buffer) {
        __classPrivateFieldSet(this, _RecipientContextImpl_mutex, __classPrivateFieldGet(this, _RecipientContextImpl_mutex, "f") ?? new Mutex(), "f");
        const release = await __classPrivateFieldGet(this, _RecipientContextImpl_mutex, "f").lock();
        let pt;
        try {
            pt = await this._ctx.key.open(this.computeNonce(this._ctx), toArrayBuffer(data), toArrayBuffer(aad));
        }
        catch (e) {
            throw new OpenError(e);
        }
        finally {
            release();
        }
        this.incrementSeq(this._ctx);
        return pt;
    }
}
_RecipientContextImpl_mutex = new WeakMap();
